import type { IFupPrescription } from "@bbj-types/socialApply/fup";
import { Stack, Typography } from "@mui/material";
import { formatPhoneNumber } from "@root/utils/phoneLib";
import { LabelInfo } from "@styleguide";

interface IVisualizePrescriptionProps {
  prescription: IFupPrescription;
}

export const VisualizePrescription = ({ prescription }: IVisualizePrescriptionProps) => {
  return (
    <Stack
      sx={{
        gap: 2,
      }}
    >
      <Typography variant="h4" color="primary">
        Prescription
      </Typography>
      <Stack
        sx={{
          gap: 2,
        }}
      >
        <Stack>
          <LabelInfo label="Prénom, Nom du référent RSA" text={prescription.rsaReferentName} />
          <LabelInfo label="Email" text={prescription.email} />
          <LabelInfo label="N° de téléphone" text={formatPhoneNumber(prescription.phone)} />
          <LabelInfo label="Structure prescriptrice" text={prescription.structure} />
          <LabelInfo label="Adresse de la structure" text={prescription.address?.formatted ?? ""} noWrap />
          <LabelInfo label="Objectifs de la prescription" text={prescription.goal} />
        </Stack>
        <Stack>
          <LabelInfo
            label="En tant qu’allocataire du RSA, j'ai pris connaissance et j'accepte la demande de prescription formulée auprès du partenaire mentionné ci-dessus"
            text={prescription.validatePrescription ? "OUI" : "NON"}
          />
          <LabelInfo
            label="En tant que prescripteur, je confirme l'exactitude des informations renseignées ci-dessus"
            text={prescription.approveDemand ? "OUI" : "NON"}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};
